<sb-card>
  <div class="flex flex-col divide-x-0 divide-y divide-solid divide-grey-200 text-word-mark-800">
    @for (absence of absences; track absence.id) {
      <absence-row [absence]="absence" [isOwnAbsence]="absence.Employee.id === authUserId" />
    }
  </div>
</sb-card>
